export const ACTIONS_REMOVE_COLLECTION_LIST = "ACTIONS_REMOVE_COLLECTION_LIST";

export const ACTIONS_GET_COLLECTIONS_LIST = "ACTIONS_GET_COLLECTIONS_LIST";

export const ACTIONS_SAVE_COLLECTIONS = "ACTIONS_SAVE_COLLECTIONS";

export const ACTIONS_CHECK_DELETE_ITEM = "ACTIONS_CHECK_DELETE_ITEM";

export const MUTATIONS_SET_COLLECTIONS_LIST = "MUTATIONS_SET_COLLECTIONS_LIST";

export const GETTERS_COLLECTIONS_LIST = "GETTERS_COLLECTIONS_LIST";



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_collection/constants.js